import { render, staticRenderFns } from "./create-bill.vue?vue&type=template&id=27bfe6aa&scoped=true"
import script from "./create-bill.vue?vue&type=script&lang=js"
export * from "./create-bill.vue?vue&type=script&lang=js"
import style0 from "./create-bill.vue?vue&type=style&index=0&id=27bfe6aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bfe6aa",
  null
  
)

export default component.exports